import { GridColDef } from "@mui/x-data-grid";
import { PolicyActionChip } from "~/components/PolicyActionChip";
import { type OrganizationPoliciesRow } from "../../hooks/useOrganizationPoliciesTableData";

export const OrganizationPoliciesTableStatusCell: GridColDef<OrganizationPoliciesRow>["renderCell"] =
  ({ row }) => {
    return <PolicyActionChip action={row.action} hideIcon />;
  };
